import classNames from 'classnames';

import { useAnchorable } from '../../hooks/useAnchorable';

import type { NodeProps } from '../types';
import { blockquoteFigure, blockquoteFigureContainer } from './BlockquoteFigure.css';
import type { BlockquoteFigure } from './BlockquoteFigure.types';

export {
  blockquoteFigure as postBlockquoteFigureVariantClasses,
  blockquoteFigureContainer as postBlockquoteFigureContainerVariantClasses,
} from './BlockquoteFigure.css';

export const PostBlockquoteFigure = ({
  element,
  children,
  className,
  // we don't want these extra props in the ...props rest since we're spreading it on a div
  isLive,
  isIndexingDisabled,
  rewriteImageSrc,
  homePath,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  ...props
}: NodeProps<BlockquoteFigure>) => {
  const { variant } = element.attrs;
  const { anchorAttributes } = useAnchorable(element?.attrs);

  /* spreading props on standard DOM elements causes React warnings and hydration errors */
  return (
    <div {...anchorAttributes} className={classNames(className, blockquoteFigureContainer[variant])} {...props}>
      <div className={classNames(className, blockquoteFigure[variant])} {...props}>
        {children}
      </div>
    </div>
  );
};
